import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-rv-proposal-vew',
  templateUrl: './rv-proposal-vew.component.html',
  styleUrls: ['./rv-proposal-vew.component.scss']
})
export class RvProposalVewComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/rv-proposal-vew/rv-proposal-vew.component.ts